import React, { ReactElement } from 'react'
import ProofOfResidencyDocument from '../../../components/verification-steps/steps/proof-of-residency/ProofOfResidencyDocument'
import verificationStore from '../../../stores/verificaton.store'

const UserProofOfResidencyDocument: React.FC = (): ReactElement => {
  return <ProofOfResidencyDocument verificationStore={verificationStore} />
}

export default UserProofOfResidencyDocument
